const formatDate = (date, format) => {
  const yyyy = date.substr(0, 4);
  const yy = date.substr(2, 2);
  const mm = date.substr(4, 2);
  const dd = date.substr(6, 2);

  if (format && format.length) {
    if (format.toLowerCase() === 'dd/mm/yyyy') {
      return `${dd}/${mm}/${yyyy}`;
    }

    if (format.toLowerCase() === 'mm/dd/yyyy') {
      return `${mm}/${dd}/${yyyy}`;
    }

    if (format.toLowerCase() === 'dd/mm/yy') {
      return `${dd}/${mm}/${yy}`;
    }

    if (format.toLowerCase() === 'mm/dd/yy') {
      return `${mm}/${dd}/${yy}`;
    }
  }

  return `${yyyy}-${mm}-${dd}`;
};

export default formatDate;
